/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Non Catalog request page component. The component displays the Non Catalog request page details.
 * 
 * App Name: SDI-Walmart
 * Author: Chandrasekar
 * Created Date: 08/11/2020 
 */
import React, { Component } from 'react';
/**
 * Ref: NC_PC_02
 * Importing the action and store file and set to an object.
 */
import * as NonCatalogAction from '../actions/NonCatalogAction';
import NonCatalogStore from '../stores/NonCatalogStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import QuickItemComponent from '../components/QuickItemComponent';
import * as MenuAction from '../actions/MenuAction';
import * as SearchResultsAction from '../actions/SearchResultsAction';
import SearchResultsStore from '../stores/SearchResultsStore';
import { withTranslation, Trans } from 'react-i18next'
import swal from 'sweetalert';
import i18n from '../i18n';
//import heic2any from "heic2any";
//window.jQuery = $;
//require("jquery-toast-plugin/dist/jquery.toast.min.js");
//require("jquery-toast-plugin/dist/jquery.toast.min.css");
let qckKeycounter = 0;
let type = 0;
let rmvAttachindex = -1;
let currentPagePath;
let Session_ZEUSNOCATALOGSITE;
let cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
const queryParams = new URLSearchParams(window.location.search)
class NonCatalogComponent extends Component {
    /**
    * Ref: NC_PC_04
    * Define the constructor that takes props as parameter
    * 
    * @param props
    */
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.saveNonCatalog = this.saveNonCatalog.bind(this);
        this.quickItemClick = this.quickItemClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
        //[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]
        this.closePopupCheckCatalog = this.closePopupCheckCatalog.bind(this);
        this.checkCatalog = this.checkCatalog.bind(this);
        this.clearFormValues = this.clearFormValues.bind(this);
        this.handleAttachment = this.handleAttachment.bind(this);
        this.loadAttachments = this.loadAttachments.bind(this);
        this.downloadAttachment = this.downloadAttachment.bind(this);
        this.bindAttachments = this.bindAttachments.bind(this);
        this.removeAttachmentResponse = this.removeAttachmentResponse.bind(this);
        this.loadFavPageResponse = this.loadFavPageResponse.bind(this);
        this.updateFavPageResponse = this.updateFavPageResponse.bind(this);
        this.handleFavorite = this.handleFavorite.bind(this);
        this.handleQuantity = this.handleQuantity.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.RedirectToItemDetail = this.RedirectToItemDetail.bind(this);
        const queryparam = new URLSearchParams(window.location.search)
        const orgin = queryparam.get('Orgin')
        /**
       * Ref: NC_PC_05
       * Set the initial values of the state variables
       */
        this.state = {
            mfgPartNumber: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_mfgPartNumber") : "",
            mfgName: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_mfgName") : "",
            recommendedSupplier: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_recommendedSupplier") : "",
            supplierPrtNbr: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_supplierPrtNbr") : "",
            description: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_description") : "",
            quantity: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_quantity") : "",
            uom: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_uom") : "",
            unitOfMeasureData: [],
            attachmentPathArr: orgin == 'itemdetail' ? CookieService.getLocalStorageValues("NonCat_attachmentPathArr") : [],
            isInvalid: false,
            txtItemID: "",
            quickItemVisible: false,
            strCplusitemid: "0",
            attachmentErrormsg: "",
            isFavorited: false,
            Page_ID: "",
            islblInfo1Visible: false,
            isCheckCatalog: false,
            isbuttonclick: false,
            newtest: queryParams,
            cartConfirmationPopupTxt: "" //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
        }
        cartDelete = false; //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
    };
    /**
   * Ref: NC_PC_06
   * componentwillMount method will be first method which will be invoked
   * when Non Catalog page is loaded
   */
    componentDidMount() {

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        console.log("hasReqApprovalCheck", CookieService.getLocalStorageValues("hasReqApprovalCheck"));
        $("#quickItemSuccess").hide();
        $(`#nonCatalogSaveSuccess`).hide();
        Session_ZEUSNOCATALOGSITE = CookieService.getLocalStorageValues("Session_ZEUSNOCATALOGSITE");
        let nonCatalogBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_USERNAME: CookieService.getLocalStorageValues("Session_USERNAME"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP")
        }
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');

        /**
        * Ref: NC_PC_08
        * Invoke the action to get the page load data from API.
        */
        NonCatalogAction.getUnitOfMeasures(nonCatalogBO);
        /**
        * Invoke the action to check the current page is favorited
        */
        NonCatalogAction.getCurrentFavPage(getFavPageBO);
        /*
         * Ref: NC_PC_07
         * Define the listener methods
         */
        NonCatalogStore.on('load', this.loadUnitOfMeasures);
        NonCatalogStore.on('save', this.saveSuccess);
        NonCatalogStore.on('quickItemCheck', this.loadQuickItem);
        NonCatalogStore.on('checkCatalogResponse', this.loadCheckCatalog);
        NonCatalogStore.on('attachmentResponse', this.loadAttachments);
        NonCatalogStore.on('rmvAttach', this.removeAttachmentResponse);
        /*
         * Favorite page response listeners
         */
        NonCatalogStore.on('favpage', this.loadFavPageResponse);
        NonCatalogStore.on('updateFavPage', this.updateFavPageResponse);
        SearchResultsStore.on('Searchresult', this.RedirectToItemDetail);
    }
    componentWillUnmount() {
        NonCatalogStore.removeListener('load', this.loadUnitOfMeasures);
        NonCatalogStore.removeListener('save', this.saveSuccess);
        NonCatalogStore.removeListener('quickItemCheck', this.loadQuickItem);
        NonCatalogStore.removeListener('checkCatalogResponse', this.loadCheckCatalog);
        NonCatalogStore.removeListener('attachmentResponse', this.loadAttachments);
        NonCatalogStore.removeListener('rmvAttach', this.removeAttachmentResponse);
        NonCatalogStore.removeListener('favpage', this.loadFavPageResponse);
        NonCatalogStore.removeListener('updateFavPage', this.updateFavPageResponse);
        SearchResultsStore.removeListener('Searchresult', this.RedirectToItemDetail);
    }
    /*
     * Listener method for the response of Save/Delete favorite page
     */
    updateFavPageResponse = () => {

        if (NonCatalogStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(NonCatalogStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(NonCatalogStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
    };
    /*
     * Handle change method for favorite page checkbox
     */
    handleFavorite = (event) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        this.setState({ isFavorited: event.target.checked });
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Non Catalog Request",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            NonCatalogAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            NonCatalogAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /*
     * Listener method for loading favorite page icon
     */
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(NonCatalogStore.currentFavPageResponse);
        console.log("favPageResponse", favPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    /*
     * Common method to refresh the master data in menu
     */
    refreshMenu = () => {
        let masterBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            isRequestorApproval: CookieService.getLocalStorageValues("hasReqApprovalCheck"),
            isOrderApproval: CookieService.getLocalStorageValues("hasOrderApprovalCheck"),
            isFavItem: CookieService.getLocalStorageValues("hasFavItemCheck"),
            isFavOrder: CookieService.getLocalStorageValues("hasFavOrderCheck"),
            isFirstTime: false,
            IsWeb: true//isFirstTimeLoaded
        };
        MenuAction.getMasterData(masterBO);
    };
    /**
    * Closepopup method for closing Quick item popup
    * @param message
    */
    closePopup = (message) => {
        $('#quickconfirm').modal('hide');
        this.setState({ strCplusitemid: "0" });
        console.log("Hit", message);
        if (message == 1) {
            $("#quickItemSuccess").show();
            $(`#nonCatalogSaveSuccess`).hide();
            //  alert(`Item ${this.state.txtItemID} has been added to cart`);
            this.refreshMenu();
        } else if (message == 2) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid data is entered for Quick Item Entry"
            });
            //  alert("Invalid data is entered for Quick Item Entry");
        };
    };
    //[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]
    closePopupCheckCatalog = (message) => {
        $('#CheckCatalogQuick').modal('hide');
        this.setState({ strCplusitemid: "0", mfgPartNumber: "" });
        console.log("Hit", message);
        if (message == 1) {
            $("#nonCatalogSaveSuccess").show();
            $(`#quickItemSuccess`).hide();
            this.refreshMenu();
        } else if (message == 2) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Invalid data is entered for check catalog"
            });
            // alert("Invalid data is entered for check catalog");
        };
    };
    /*
     * Ref: NC_PC_13
     * Listener method of remove attachment response
     */
    removeAttachmentResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let isValid = NonCatalogStore.removeAttachmentResponse.indexOf("success") >= 0 ? true : false;
        if (isValid) {
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments.splice(rmvAttachindex, 1);
            this.setState({ attachmentPathArr: tempAttachments });
            rmvAttachindex = -1;
        }
    };
    /*
     * Ref: NC_PC_17
     * Listener method of loading attachments
     */
    loadAttachments = () => {
        const { t } = this.props
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        $(`#nAttachments`).val('');
        let isValid = NonCatalogStore.attachmentResponse.indexOf("You have exceeded the length of total file names") >= 0 ? false : true;
        if (isValid) {
            let attachmentResponse = JSON.parse(NonCatalogStore.attachmentResponse);
            let tempAttachments = this.state.attachmentPathArr;
            tempAttachments = tempAttachments.concat(attachmentResponse);
            this.setState({ attachmentPathArr: tempAttachments });
            console.log("tempAttachments", tempAttachments);
        } else {
            this.setState({
                attachmentErrormsg: t("You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names.")
            });
        }
    };
    /** 
    * Ref: NC_PC_10
    * Handle method for attachments on change
    * @param event
    */
    handleAttachment = (event) => {
        const { t } = this.props
        let files = event.target.files;
        //WW-311 Non - Catalog Attachments should allow attachments of type pdf or Img - Deepthi
        let filetype = files[0].type;
        if (!(filetype.toLowerCase().includes('jpg') || (filetype.toLowerCase().includes('png')) || (filetype.toLowerCase().includes('jpeg')) || (filetype.toLowerCase().includes('pdf')))) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("You can choose only the Image and PDF files!!")
            });
            //alert("You can choose only the Image and PDF files!!");
            return;
        }
        console.log("event", files);
        if (files.length > 0) {
            this.setState({ attachmentErrormsg: "" });
            if (this.state.attachmentPathArr.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    let isDuplicate = this.state.attachmentPathArr.filter((attach) => attach.FileName == files[i].name).length > 0 ? true : false;
                    if (isDuplicate) {
                        this.setState({ attachmentErrormsg: t("Selected file is already attached, please try again") });
                        return false;
                    }
                }
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            NonCatalogAction.addAttachment(files);
        }

    };
    /**
    * Ref: NC_PC_12
    * Listener method of downloading attachments
    * @param e
    * @param attachment
    */
    downloadAttachment = (e, attachment) => {
        e.preventDefault();
        let downloadBO = {
            fileName: attachment.FileName,
            filePath: attachment.FilePath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.downloadAttachment(downloadBO);
    };
    /**
     * Ref: NC_PC_13
     * On click method of removing attachments
     * @param filepath
     * @param index
     */
    removeAttachments = (filepath, index) => {
        console.log(filepath);
        rmvAttachindex = index
        let removeBO = {
            filePath: filepath
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.removeAttachment(removeBO);
    }
    /**
    * Binding attachments using map function
    */
    bindAttachments = () => {
        return this.state.attachmentPathArr.map((attachment, index) => {
            return (
                <span className="attachment-file-name pl-0 my-2 pr-3 d-inline-block" key={index}>
                    <a href="#" className="noncat-Attachment-overflow" data-toggle="tooltip" title={attachment.FileName} onClick={(e) => this.downloadAttachment(e, attachment)}>{attachment.FileName}</a>
                    <span className="attachment-remove-icon ml-1" onClick={() => this.removeAttachments(attachment.FilePath, index)}>X</span>
                </span>
            );
        });
    };
    /**
     * Ref:NC_PC_16
     * Listner method for check catalog response
     */
    loadCheckCatalog = () => {
        const { t } = this.props
        //[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]
        let quickItemChkRes = JSON.parse(NonCatalogStore.quickItemcheck)[0];
        qckKeycounter = qckKeycounter + 1;
        if (quickItemChkRes.strCplusitemid != "0") {
            $('#CheckCatalogQuick').modal('show');
            this.setState({ strCplusitemid: quickItemChkRes.strCplusitemid })
        } else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Item does not exist in the catalog.")
            });
            //alert("Item does not exist in the catalog.");
        }
    }
    /**
     * Ref:NC_PC_19
     * Listner method for quick item check response
     */
    loadQuickItem = () => {
        const { t } = this.props
        let quickItemChkRes = JSON.parse(NonCatalogStore.quickItemcheck)[0];
        qckKeycounter = qckKeycounter + 1;
        if (quickItemChkRes.strCplusitemid != "0") {
            $('#quickconfirm').modal('show');
            this.setState({ strCplusitemid: quickItemChkRes.strCplusitemid })
        } else {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Invalid Item Number entered for Quick Item Entry")
            });
            // alert("Invalid Item Number entered for Quick Item Entry");
        }
        // this.setState({ quickItemVisible: true });
    }
    /**
    * Reusable method to clear form values
    */
    clearFormValues = () => {
        $("#quickItemSuccess").hide();
        $(`#nonCatalogSaveSuccess`).hide();
        
        let test = JSON.parse(localStorage.getItem("SDIFavItems"))
        console.log("FavItem_Cat_SubCat", test)
        // alert("onblur button click")
        // $(this).off("blur")
        //  event.stopPropagation()
        let uomDefaultValue = this.state.unitOfMeasureData.filter((item) => item.UNIT_OF_MEASURE == "EA").length > 0 ? "EA" : "";
        this.setState({
            mfgPartNumber: "",
            mfgName: "",
            recommendedSupplier: "",
            supplierPrtNbr: "",
            description: "",
            quantity: "",
            uom: uomDefaultValue,
            attachmentPathArr: [],
            txtItemID: "",
            strCplusitemid: "0",
            attachmentErrormsg: "",
            isInvalid: false,
            isbuttonclick: true
        });
    };
    /**
     * Ref:NC_PC_18
     * Listener method after saving non catalog request to cart
     */
    saveSuccess = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let saveResponse = JSON.parse(NonCatalogStore.saveResponse);
        console.log("saveResponse", saveResponse);
        if (type == 1) {
            this.clearFormValues();
            
            $(`#nonCatalogSaveSuccess`).show();
        } else {
            this.props.history.push({
                pathname: "/shoppingcart",
            });
        }
    };
    /**
    * Ref:NC_PC_14
    * Click method of quick item entry
    */
    quickItemClick = () => {
        $("#quickItemSuccess").hide();
        if (this.state.txtItemID.trim()) {
            //let quickItemBO = {
            //    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            //    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            //    Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            //    Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            //    txtItemID: this.state.txtItemID.trim(),
            //    Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
            //    Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
            //    Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE")
            //};
            qckKeycounter = qckKeycounter + 1;
            this.setState({ strCplusitemid: qckKeycounter, isCheckCatalog: false })//[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R] //quickItemChkRes.strCplusitemid
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            $('#quickconfirm').modal('show');
            //NonCatalogAction.QuickItemCheck(quickItemBO);
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter item ID'
            });
            //  alert('Please enter item ID');
        }
    }
    /**
     * Ref:NC_PC_09
     * Click method of Check catalog click
     */
    //[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]
    checkCatalog = (event) => {
        const { t } = this.props
        event.preventDefault();
        $(`#nonCatalogSaveSuccess`).hide();
        if (this.state.mfgPartNumber) {
            qckKeycounter = qckKeycounter + 1;
            this.setState({ strCplusitemid: qckKeycounter, isCheckCatalog: true })//quickItemChkRes.strCplusitemid           
            $('#CheckCatalogQuick').modal('show');
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        } else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Manufacturer part number is required to check the catalog.")
            });
            //  alert("Manufacturer part number is required to check the catalog.");
        }
    };
    /**
    * Ref:NC_PC_15
    * Listener method for loading unit of measures data
    */
    loadUnitOfMeasures = () => {
        let pageLoadResponse = JSON.parse(NonCatalogStore.pageLoadData);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        console.log("pageLoadResponse", pageLoadResponse);
        if (pageLoadResponse.FlagData.length > 0) {
            let islblInfo1VisibleRes = pageLoadResponse.FlagData[0].islblInfo1Visible.toLowerCase() == `true`;
            this.setState({ islblInfo1Visible: islblInfo1VisibleRes });
        }

        if (pageLoadResponse.Data) {
            var obj = {};
            for (var i = 0, len = pageLoadResponse.Data.length; i < len; i++)
                obj[pageLoadResponse.Data[i]['DESCR']] = pageLoadResponse.Data[i];

            pageLoadResponse.Data = new Array();
            for (var key in obj)
                pageLoadResponse.Data.push(obj[key]);
            let uomDefaultValue = pageLoadResponse.Data.filter((item) => item.UNIT_OF_MEASURE == "EA").length > 0 ? "EA" : "";

            this.setState({ unitOfMeasureData: pageLoadResponse.Data, uom: uomDefaultValue });
        }
    };
    /**
     * Ref:NC_PC_20
     * Bind method for UOM dropdown
     */
    bindUOMDropdown = () => {
        return this.state.unitOfMeasureData.map((uom, index) => {
            return (<option key={index} value={uom.UNIT_OF_MEASURE}>{uom.DESCR}</option>)
        });
    };
    /**
     * Handle method for quantity textbox
     */
    handleQuantity = (e) => {
        const re = SDIConstants.quantityRegEX;
        if (e.target.value === '' || re.test(e.target.value)) {

            this.setState({ quantity: e.target.value });

        }

    }

        ;
    /**
     * Handle method for all form input controls
     */
    handleChange = (event) => {
        $("#quickItemSuccess").hide();
        //  alert("handlechagne")
        this.setState({ [event.target.name]: event.target.value });
        console.log("value", event.target.value);
    };
    /**
     * Click method for cancel button
     */
    cancelClick = () => {
        this.props.history.push({
            pathname: "/HomePage",
        });
    };

    handleEquipmentYes = () => {
        $('#NonCatMixedOrderConfirmPopup').modal('hide');
        cartDelete = true;
        this.saveNonCatalog(this.state.pendingSaveType);
    };

    handleEquipmentNo = () => {
        $('#NonCatMixedOrderConfirmPopup').modal('hide');
        cartDelete = false;
    };

    /**
     * Ref:NC_PC_11
     * Click method for Save and Save/More buttons
     * @param saveType
     */
    saveNonCatalog = (saveType) => {
        const { t } = this.props
        $(`#nonCatalogSaveSuccess`).hide();
        //pc-676-162 to 171 to equipments delete S.Sanjay 11/26/24
        let cartItems = JSON.parse(localStorage.getItem('CartStorage')) || [];
        if (cartItems != undefined && cartItems != null && cartItems.length > 0) {
            let hasEquipmentItem = cartItems.filter(item => item.ISA_WBS_ELMNT === 'Equipment');
            let hasQuoteItem = cartItems.filter(item => item.ISA_QUOTE_REF && item.ISA_QUOTE_REF.startsWith('WQ'));
            if (!cartDelete && hasEquipmentItem != undefined && hasEquipmentItem != null && hasEquipmentItem.length > 0) {
                $('#NonCatMixedOrderConfirmPopup').modal('show');
                this.setState({ pendingSaveType: saveType, cartConfirmationPopupTxt: "Adding an item will remove the equipment items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
            else if (!cartDelete && hasQuoteItem != undefined && hasQuoteItem != null && hasQuoteItem.length > 0) { //[12/06/2024, WW-1221 Preventive work order -Vishwa S]
                $('#NonCatMixedOrderConfirmPopup').modal('show');
                this.setState({ pendingSaveType: saveType, cartConfirmationPopupTxt: "Adding an item will remove the quote items in your shopping cart. Do you want to proceed with this change?" });
                return;
            }
        }


        this.setState({ isbuttonclick: true });
        if (!this.state.mfgPartNumber || !this.state.mfgName || !this.state.quantity || !this.state.description || !this.state.uom) {

            this.setState({ isInvalid: true });


            return false
        }
        {/*[07/21/2022PC_01 WAL-819 ISSUE] Pavithra R*/ }
        if (parseInt(this.state.quantity) == 0 || this.state.quantity == "") {
            //this.setState({ isInvalid: true });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: t("Please enter a valid Quantity")
            });
            // alert("Please enter a valid Quantity")
            return false
        }


        let attachmentStr = "";
        //let testattachment = "https://alexcorvi.github.io/heic2any/demo/14.heic";
        if (this.state.attachmentPathArr.length > 0) {
            attachmentStr = this.state.attachmentPathArr.map(e => e.FilePath).join("|");
            if (attachmentStr.length > 254) {
                this.setState({
                    attachmentErrormsg: "You have exceeded the length of total file names. \nPlease adjust your entry or remove longer file names."
                });
                return false;
            }

            //else {
            //    if (testattachment.includes(".heic")) {
            //        let conurl = fetch(testattachment, {
            //            method: 'GET',
            //            headers: {

            //                'Access-Control-Allow-Credentials': true,
            //                'Access-Control-Allow-Headers': 'Content-type',
            //                "Content-type": "application/json; charset=UTF-8",
            //                'Access-Control-Allow-Methods': 'POST, GET'
            //            }
            //        })
            //            .then((res) => res.blob())
            //            .then((blob) => heic2any({
            //                blob,
            //                toType: "image/jpeg",
            //                quality: 0.3,
            //                multiple: true
            //            }))
            //            .then((conversionResult) => {
            //                //document.getElementById("target").innerHTML = '';
            //                conversionResult.forEach(image => {
            //                    //var url = URL.createObjectURL(image);
            //                    //return url;
            //                    return conversionResult.json();
            //                    // document.getElementById("target").innerHTML = document.getElementById("target").innerHTML + `<a target="_blank" href="${url}"><img src="${url}"></a>`;
            //                    console.log("imgcon", conversionResult.JSON());
            //                });

            //            })
            //            .catch((e) => {
            //                console.log(e);
            //            });
            //        console.log("imgcon1", conurl);
            //    }

            //}
        }

        let savenonCatalogBO = {
            txtSupplier: this.state.recommendedSupplier.trim(),
            txtSuppPartNum: this.state.supplierPrtNbr.trim(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
            Session_AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
            Session_PUNCHIN: CookieService.getLocalStorageValues("Session_PUNCHIN"),
            txtEstPrice: "",
            txtDesc: this.state.description.trim(),
            txtMfgPartNum: this.state.mfgPartNumber.trim(),
            txtMfgName: this.state.mfgName.trim(),
            txtQty: this.state.quantity,
            DropUOM: this.state.uom,
            rblcatalogVisible: false,
            Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
            filePath: attachmentStr,
            Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna               
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"), //pc-676-152 to 161 equipmentparts mixed cart restriction S.Sanjay11/29/2024
            EquipmentDelete: cartDelete,
            Interactive: false

        };
        this.setState({ isInvalid: false });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        NonCatalogAction.saveNonCatalog(savenonCatalogBO);
        type = saveType;
    };
    NonCatSearch = (event) => {
        if (this.state.mfgName != "" && this.state.mfgPartNumber != "") {
            if (this.state.isbuttonclick == false) {
                let SearchBO = {
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    AGENTUSERID: CookieService.getLocalStorageValues("Session_AGENTUSERID"),
                    AGENTUSERBU: CookieService.getLocalStorageValues("Session_AGENTUSERBU"),
                    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                    CurrentPage_URL: "/SDIXZEUS/searchResults",
                    Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                    Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                    Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                    Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                    Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                    Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                    Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                    Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                    Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                    Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                    Session_SearchQuery: this.state.mfgPartNumber,
                    Session_AMAZONSEARCH: CookieService.getLocalStorageValues("Session_AMAZONSEARCH"),
                    SearchValue: this.state.mfgPartNumber,
                    Query_SITE: "",
                    Query_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Query_Key: this.state.mfgPartNumber,
                    Query_Opt: "",
                    chbCat: true,
                    chbNonCat: true,
                    Catagorylist: [],//CatagoryList,	
                    Make: "",
                    Model: "",
                    AssetId: "",
                    SupplierIdList: "",
                    ManufacturerList: "",
                    WorkOrder: localStorage.getItem("WONum") != null ? JSON.parse(localStorage.getItem("WONum")) : "",
                    ShipToID: CookieService.getLocalStorageValues("HOME_STORE") != null && CookieService.getLocalStorageValues("HOME_STORE") != undefined && CookieService.getLocalStorageValues("HOME_STORE") != "" ? CookieService.getLocalStorageValues("HOME_STORE") : " ",//localStorage.getItem("StoreValue") != null ? JSON.parse(localStorage.getItem("StoreValue")) : "", //WAL-767 -Aparna
                    /*[12/24/21, PC_SC_06], Priyanka D//Passing the Location value */
                    /*Location: CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("LOCATION").substring(0, 2) : "",*/
                    Location: CookieService.getLocalStorageValues("Session_WO_STATE") != undefined && CookieService.getLocalStorageValues("Session_WO_STATE") != null && CookieService.getLocalStorageValues("Session_WO_STATE") != "" ? CookieService.getLocalStorageValues("Session_WO_STATE") : CookieService.getLocalStorageValues("Session_STATE") != undefined && CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "", //WW-1231 WO State Restriction -Vishwa S
                    FavYourCatg: "",
                    Session_ID: CookieService.getLocalStorageValues("Session_ID"), //WW-390_PC_05 (4/20/2022)-Aparna
                    SOURCE: "WEB",
                    IsNonCatalogSearch: true,
                    IsSupplierSearch: true,
                    mfg: this.state.mfgName,
                    mfgpartno: this.state.mfgPartNumber
                }
                SearchResultsAction.GetpageLoad(SearchBO)
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            }
        }
        this.setState({ isbuttonclick: false })
        return true

    }
    //
    RedirectToItemDetail = () => {
        let response = JSON.parse(SearchResultsStore.SearchresultList);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Searchdata = response.SearchItemTable;
        if (Searchdata.length > 0) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            CookieService.updateLocalStorageValues("NonCat_mfgPartNumber", this.state.mfgPartNumber)
            CookieService.updateLocalStorageValues("NonCat_mfgName", this.state.mfgName)
            CookieService.updateLocalStorageValues("NonCat_recommendedSupplier", this.state.recommendedSupplier)
            CookieService.updateLocalStorageValues("NonCat_supplierPrtNbr", this.state.supplierPrtNbr)
            CookieService.updateLocalStorageValues("NonCat_description", this.state.description)
            CookieService.updateLocalStorageValues("NonCat_quantity", this.state.quantity)
            CookieService.updateLocalStorageValues("NonCat_uom", this.state.uom)
            CookieService.updateLocalStorageValues("NonCat_attachmentPathArr", this.state.attachmentPathArr)
            CookieService.updateLocalStorageValues("ItemDetail_ItemId", Searchdata[0].clientPartNumber)
            CookieService.updateLocalStorageValues("ItemDetail_ManufacturePartNumber", Searchdata[0].manfPartNumber)
            CookieService.updateLocalStorageValues("ItemDetail_ManufactureName", Searchdata[0].manufacturer)
            CookieService.updateLocalStorageValues("ItemDetail_SupplierID", Searchdata[0].vendor_id)
            CookieService.updateLocalStorageValues("ItemDetail_QTY", "1")
            this.props.history.push({
                pathname: `\itemdetailnew`,
                search: `?ItemId=${Searchdata[0].clientPartNumber}&ManufacturePartNumber=${Searchdata[0].manfPartNumber}&ManufactureName=${Searchdata[0].manufacturer}&SupplierID=${Searchdata[0].vendor_id}&QTY=""&Orgin=noncat`,
                state: { WO: JSON.parse(localStorage.getItem("WONum")), Orgin: 'noncat', Suggesstions: false, ItemData: Searchdata[0], ItemId: Searchdata[0].clientPartNumber, ManufacturePartNumber: Searchdata[0].manfPartNumber, ManufactureName: Searchdata[0].manufacturer, SupplierID: Searchdata[0].vendor_id, QTY: "1" }
            });
        }
    }

    /**
     * Ref:NC_PC_20
     * Render method to bind the controls
     */
    render() {
        const { t } = this.props;
        return (
            <div className="container-fluid content-section">
                <div className="row">
                    <div className="container-fluid content-margin">
                        <div className="row non-catalog-req-form">
                            <div className="col-md-12 page-heading mb-3">
                                <h5 className="page-title"><Trans>Non-Catalog Request</Trans></h5>
                                {/*<div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-1" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-1">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>*/}
                            </div>
                            <div className="col-md-12 form-container">
                                <span className="float-right indicate-alert"><Trans>Required_key</Trans></span>
                            </div>
                            {/*  Session_ZEUSNOCATALOGSITE != `Y` ? <div className="col-md-12 mb-4">
                                <div className="col-md-4 input-group charge-code-group mr-3">
                                   
                                    <input type="text" className="form-control charge-code-control" maxLength="100" placeholder="Search for the product" value={this.state.txtItemID} name="txtItemID" onChange={this.handleChange} />
                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <span className="shopping-search-icon" data-backdrop="static" data-keyboard="false" onClick={this.quickItemClick} />
                                        </span>
                                    </div>

                                </div> 
                            
                                <span className="float-left err-msg text-danger col-md-12 text-center bold" id="quickItemSuccess">{`Item ${this.state.txtItemID} has been added to cart`}</span>
                            </div> : null*/}
                            <span className="float-left err-msg text-danger col-md-12 text-center bold mb-3" id="nonCatalogSaveSuccess"><Trans>Itemaddedtocart_key</Trans></span>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 mandatory-after form-label catalog-label"><Trans>Manufacturer</Trans><span> </span><Trans>Name</Trans><span></span></label>
                                <div className="float-left col-md-7 p-0">
                                    <input type="text" className="form-control" name="mfgName" maxLength="30" placeholder="Enter Name" value={this.state.mfgName} onChange={this.handleChange} onBlur={e => this.NonCatSearch(e)} />
                                    {this.state.isInvalid && this.state.mfgName == "" ? <span className="float-left err-msg text-danger">Please enter manufacturer name</span> : null}
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 mandatory-after form-label catalog-label"><Trans>Manufacturer</Trans><span> </span><Trans>part number</Trans><span></span></label>
                                <div className="float-left col-md-7 p-0">
                                    <input type="text" className="form-control" name="mfgPartNumber" maxLength="50" value={this.state.mfgPartNumber} placeholder="Enter Value" onChange={this.handleChange} onBlur={e => this.NonCatSearch(e)} />
                                    {this.state.isInvalid && this.state.mfgPartNumber == "" ? <span className="float-left err-msg text-danger">Please enter manufacturer part number</span> : null}
                                    {/*[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]*/}
                                    {/*{Session_ZEUSNOCATALOGSITE != `Y` ? <p className="float-left col-md-12 p-0 helptext my-2"><a href="#" className="helptext-link mr-1" onClick={this.checkCatalog}><Trans>Check Catalog</Trans></a><span> (MFG </span><Trans>part number</Trans><span> </span><Trans>Required</Trans><span>)</span></p> : null}*/}
                                </div>
                            </div>

                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 form-label catalog-label"><Trans>recommended</Trans><span> </span><Trans>Supplier</Trans></label>
                                <input type="text" className="float-left col-md-7 form-control" maxLength="30" placeholder="Enter Value" value={this.state.recommendedSupplier} name="recommendedSupplier" onChange={this.handleChange} />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 form-label catalog-label"><Trans>Supplier</Trans><span> </span><Trans>part number</Trans></label>
                                <input type="text" className="float-left col-md-7 form-control" maxLength="100" placeholder="Enter Value" name="supplierPrtNbr" value={this.state.supplierPrtNbr} onChange={this.handleChange} />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 mandatory-after form-label catalog-label"><Trans>Description</Trans><span> </span></label>
                                <div className="float-left col-md-7 p-0">
                                    <textarea className="form-control custom-textarea" maxLength="254" placeholder="Enter Description" name="description" value={this.state.description} onChange={this.handleChange} />
                                    {this.state.isInvalid && this.state.description == "" ? <span className="float-left err-msg text-danger">Please enter description</span> : null}
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 mandatory-after form-label catalog-label"><Trans>Quantity</Trans><span> </span></label>
                                <div className="float-left col-md-7 p-0">
                                    <input type="text" className="form-control" maxLength="8" placeholder="Enter Value" name="quantity" value={this.state.quantity} onChange={this.handleQuantity} />
                                    {this.state.isInvalid && this.state.quantity == "" ? <span className="float-left err-msg text-danger">Please enter quantity</span> : null}

                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 form-label catalog-label"><Trans>unitofmeasure_key</Trans></label>
                                <div className="float-left col-md-7 p-0">
                                    <select className="form-control" name="uom" value={this.state.uom} onChange={this.handleChange}>
                                        {this.bindUOMDropdown()}
                                    </select>
                                    {this.state.islblInfo1Visible ? <span className="float-left err-msg text-danger">Warning! Default UOM list displayed - no cross reference data available for the current Business Unit</span> : null}
                                    {/* {this.state.isInvalid && this.state.uom == "" ? <span className="float-left err-msg text-danger">Please select UOM</span> : null}*/}
                                </div>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label className="float-left col-md-5 form-label catalog-label"><Trans>attachment_key</Trans></label>
                                {/* <input type="file" class="float-left col-md-7 form-control"/> */}
                                <div className="col-md-7 custom-file mb-3 p-0">
                                    <input type="file" className="custom-file-input" title=" " accept="application/pdf, image/jpeg, image/png" id="nAttachments" name="filename" onChange={this.handleAttachment} />
                                    <label className="custom-file-label" htmlFor="customFile"><Trans>ChooseFile</Trans></label>
                                    {this.bindAttachments()}
                                    <div className="err-msg text-danger w-100 "><Trans>{this.state.attachmentErrormsg}</Trans></div>
                                </div>
                            </div>
                            <div className="col-md-12 float-left">
                                <div className="float-right mobile-catalog-btns">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn float-none non-catalog-mobile-btn px-5 mr-3" onMouseDown={this.cancelClick}><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-save-btn primary-btn float-none non-catalog-mobile-btn px-5 mr-3" onMouseDown={e => this.clearFormValues()}><Trans>reset_key</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn float-none non-catalog-mobile-btn px-5 mr-3" onMouseDown={() => this.saveNonCatalog(1)}><Trans>save_key</Trans><span>/More</span></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn float-none non-catalog-mobile-btn px-5" onMouseDown={() => this.saveNonCatalog(2)}><Trans>save_key</Trans><span>/Done</span></button>
                                </div>
                            </div>
                            <p className="NC-helptext col-md-12 float-left my-5"><span>** </span><Trans> Non-Catalog Orders require an additional process and you will be notified via email when your quote is available. At which point you will need to come back to this catalog to approve for final procession.</Trans>
                                <span>**</span></p>
                        </div>
                    </div>
                </div>
                {/*[9/9/22, Bug - 2557 - Check Catalog SOLR Call, Dhevanesm R]*/}
                <div className="modal" id="quickconfirm" data-backdrop="static" data-keyboard="false">
                    {this.state.isCheckCatalog != true && this.state.strCplusitemid && this.state.strCplusitemid != "0" ? <QuickItemComponent key={qckKeycounter} IsFav={false} itemid={this.state.txtItemID.trim()} closePopup={this.closePopup} cpitemid={this.state.strCplusitemid} pageNo={1} {...this.props} /> : null}
                </div>
                <div className="modal" id="CheckCatalogQuick" data-backdrop="static" data-keyboard="false">
                    {this.state.isCheckCatalog != false && this.state.strCplusitemid && this.state.strCplusitemid != "0" ? <QuickItemComponent key={qckKeycounter} IsFav={false} itemid={this.state.mfgPartNumber.trim()} closePopup={this.closePopupCheckCatalog} cpitemid={this.state.strCplusitemid} pageNo={1} {...this.props} /> : null}
                </div>

                {/* <!--MixedCart Confirmation popup Modal Starts here-->*/}
                <div className="modal fade p-0" id="NonCatMixedOrderConfirmPopup" data-backdrop="static"
                    tabIndex={-1}
                    role="dialog"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-m modal-dialog-centered mixedcart-confirmation-modal" role="document">
                        <div className="modal-content border-0">
                            <div className="modal-header sp-delv-header align-items-center px-4">
                                <h5 className="modal-title" id="exampleModalLongTitle">
                                    <Trans>Confirmation</Trans>
                                    </h5>
                            </div>
                            <div className="modal-body font-15 px-4">
                                <Trans>{this.state.cartConfirmationPopupTxt}</Trans>
                            </div>

                            {/*button*/}
                            <div className="modal-footer border-0 px-4">
                                <button className="btn btn-light-grey font-14 font-medium mr-3 px-4"
                                    type="button"
                                    data-dismiss="modal" onClick={() => this.handleEquipmentNo()}  ><Trans>No</Trans></button>

                                <button
                                    className="btn btn-custom-primary font-14 font-medium px-4" onClick={() => this.handleEquipmentYes()}
                                    type="button"><Trans>Yes</Trans></button>

                            </div>
                            {/*button*/}
                        </div>
                    </div>
                </div>
                {/*<!--MixedCart Confirmation popup Modal Ends here-->*/}

            </div>);

    };
}
export default withTranslation()(NonCatalogComponent);